module.exports = __webpack_public_path__ + "static/media/2.2ad6a1cf.JPG";